export default __webpack_public_path__ + "static/media/zine-cover10.32c3f922.png";